export const getButtonSizesExperiments = (isMobile: boolean) => {
  const sizeOfBackButton = isMobile ? 4 : 2
  const sizeOfContinueWithoutDacButton = isMobile ? 8 : 6
  const sizeOfContinueButton = isMobile ? 8 : 6
  const sizeOfSaveButton = 12 // not visible
  const sizeOfContinueWithDacButton = 12 // not visible

  return {
    sizeOfContinueButton,
    sizeOfBackButton,
    sizeOfSaveButton,
    sizeOfContinueWithDacButton,
    sizeOfContinueWithoutDacButton
  }
}
